import { z } from "zod";

/**
 * AI Model Family Schema
 * @package @genieartinc/schemas
 *
 * Single source of truth for Model Family types used across the platform.
 * Model families group AI models by research lineage (e.g., FLUX, Stable Diffusion, Kling).
 */

// Main Model Family Schema
export const AiModelFamilySchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  logoUrl: z.string().nullable().optional(),
  avgScore: z.number().nullable().optional(),
  modelCount: z.number().default(0),
  enabled: z.boolean().default(true),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AiModelFamily = z.infer<typeof AiModelFamilySchema>;

// Create DTO
export const CreateAiModelFamilySchema = AiModelFamilySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  avgScore: true,
  modelCount: true,
});

export type CreateAiModelFamily = z.infer<typeof CreateAiModelFamilySchema>;

// Update DTO
export const UpdateAiModelFamilySchema = z.object({
  name: z.string().optional(),
  slug: z.string().optional(),
  description: z.string().nullable().optional(),
  logoUrl: z.string().nullable().optional(),
  enabled: z.boolean().optional(),
});

export type UpdateAiModelFamily = z.infer<typeof UpdateAiModelFamilySchema>;

// Filter DTO
export const AiModelFamilyFiltersSchema = z.object({
  search: z.string().optional(),
  enabled: z.boolean().optional(),
});

export type AiModelFamilyFilters = z.infer<typeof AiModelFamilyFiltersSchema>;
